var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigmaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5869 19.9999C13.5869 16.3181 16.5717 13.3333 20.2536 13.3333C23.9354 13.3333 26.9203 16.3181 26.9203 19.9999C26.9203 23.6819 23.9354 26.6666 20.2536 26.6666C16.5717 26.6666 13.5869 23.6819 13.5869 19.9999Z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.253906 33.3334C0.253906 29.6516 3.23867 26.6667 6.92058 26.6667H13.5872V33.3334C13.5872 37.0153 10.6025 40.0001 6.92058 40.0001C3.23867 40.0001 0.253906 37.0153 0.253906 33.3334Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5869 0V13.3333H20.2536C23.9355 13.3333 26.9203 10.3486 26.9203 6.66667C26.9203 2.98477 23.9355 0 20.2536 0H13.5869Z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.253906 6.66667C0.253906 10.3486 3.23867 13.3333 6.92058 13.3333H13.5872V0H6.92058C3.23867 0 0.253906 2.98477 0.253906 6.66667Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.253906 19.9999C0.253906 23.6819 3.23867 26.6666 6.92058 26.6666H13.5872V13.3333H6.92058C3.23867 13.3333 0.253906 16.3181 0.253906 19.9999Z",
    fill: "#A259FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaIcon);
export default __webpack_public_path__ + "static/media/figma-icon.d5089ebb004c9c262d220d7620301045.svg";
export { ForwardRef as ReactComponent };